import { useEffect, useRef, useState} from 'react';
import { Field} from "formik";
import Select from "react-select";
import ReactDOMServer from "react-dom/server";
import Translator from "../../../../components/helpers/Translator";
import AppModal from "../../../../components/Modal/AppModal";
import styled from "styled-components";
import { AppRemixIcon } from '@/layout/AppComponents';

const BlockScorecard = props => {
    const {setFieldValue, values, disabled, report, onLevelUp} = props;
    const [showPasteModal, setShowPasteModal] = useState(false);
    const pasteValues = useRef(null)
    const [showLevelUpModal, setShowLevelUpModal] = useState(false);
    const [levelUpOption, setLevelUpOption] = useState(null);
    const [nivo, setNivo] = useState(null);
    const createChartValue = type => ({
        data: Array(6).fill().map((_, i) => ({
            column: `${ReactDOMServer.renderToString(<Translator file='module-saicaReports' name='month' />)} ${i+1}`,
            Ratio: Number(values.scorecard[type][i].replace(",", "."))
        }))
    });
    const [chart1, setChart1] = useState(createChartValue('safetyIndex'));
    const [chart2, setChart2] = useState(createChartValue('lta'));
    const [chart3, setChart3] = useState(createChartValue('mt'));
    const [chart4, setChart4] = useState(createChartValue('fa'));
    const [chart5, setChart5] = useState(createChartValue('dl'));
    const [chart6, setChart6] = useState(createChartValue('ltafr'));

    useEffect(() => {
        import("@nivo/bar")
            .then((block) => {
                setNivo(block);
            });
    }, []);

    const handleLevelUp = async() => {
        try{
            const pgID = levelUpOption;
            setLevelUpOption(null)
            await onLevelUp({values: values.scorecard, plantGroupID: pgID, type: 'scorecard'})
            setShowLevelUpModal(false)
        }catch (err) {}
    }

    useEffect(() => {
        setChart1(createChartValue('safetyIndex'))
        setChart2(createChartValue('lta'))
        setChart3(createChartValue('mt'))
        setChart4(createChartValue('fa'))
        setChart5(createChartValue('dl'))
        setChart6(createChartValue('ltafr'))
    },[values.scorecard])

    const setPasteValues = (type, cells, position) => Array(6).fill().map((_, i) => setFieldValue(`scorecard.${type}[${i}]`, cells[position][i]))

    const handlePasteValues = () => {
        const values = pasteValues.current.value;
        const splittedRow = values.split('\n')
        const splittedCell = splittedRow.map((e) => {
            const splitted = e.split('\t')
            if(splitted.length === 6)
                return splitted
            else
                return undefined
        })
        const out = splittedCell.filter(e => {return e !== undefined})
        if(out.length === 6)
        {
            setPasteValues('safetyIndex', out, 0);
            setPasteValues('lta', out, 1);
            setPasteValues('mt', out, 2);
            setPasteValues('fa', out, 3);
            setPasteValues('dl', out, 4);
            setPasteValues('ltafr', out, 5);
        }
        setShowPasteModal(false)
    }

    return (
        <div className="row mb-3">
            <div className="col-12">
                <div className="card sr-header mb-3">
                    <div className="card-header">
                        <b><Translator file='module-saicaReports' name='accident.status.balanced.scorecard' /></b>
                        {values.scorecard.originTier && <span className="btn btn-xs btn-warning" style={{marginLeft: '10px'}}><Translator file='module-saicaReports' name='from' />: <b>{values.scorecard.originTier}</b></span>}
                        <span className={`float-right btn btn-info btn-sm pointer mr-2 ${!report.levelUpPermissions && 'disabled'}`} onClick={() => report.levelUpPermissions && setShowLevelUpModal(true)}><AppRemixIcon icon="corner-right-up" /></span>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-8">
                                <Translator file='module-saicaReports' name='goal.perform.accident.rate' /><br />
                                <small>(<Translator file='module-saicaReports' name='graphs.generated.analyze.evolution' />)</small>
                            </div>
                            <div className="col-4">
                                <div className="row">
                                    <div className="col-4 text-rigth">
                                        <label className="col-form-label">
                                            <Translator file='module-saicaReports' name='s.i.target' />
                                        </label>
                                    </div>
                                    <div className="col-8">
                                        <Field name={`scorecard.siTarget`}  className={"form-control"} disabled={disabled} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br/>
                        <span className={`btn btn-sm btn-info mb-2 ${disabled && 'disabled'}`}
                              onClick={() => disabled === false && setShowPasteModal(true)}>
                            <AppRemixIcon icon="file-copy" /> <Translator file='module-saicaReports' name='paste.xls.values' />
                        </span>
                        <div>
                            <table className="table table-bordered">
                                <thead>
                                <tr>
                                    <th><Translator file='module-saicaReports' name='kpi' /></th>
                                    <th><Translator file='module-saicaReports' name='month' /> 1</th>
                                    <th><Translator file='module-saicaReports' name='month' /> 2</th>
                                    <th><Translator file='module-saicaReports' name='month' /> 3</th>
                                    <th><Translator file='module-saicaReports' name='month' /> 4</th>
                                    <th><Translator file='module-saicaReports' name='month' /> 5</th>
                                    <th><Translator file='module-saicaReports' name='month' /> 6</th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><Translator file='module-saicaReports' name='safety.index' /></td>
                                        <td className="text-center"><Field name={`scorecard.safetyIndex[0]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.safetyIndex[1]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.safetyIndex[2]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.safetyIndex[3]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.safetyIndex[4]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.safetyIndex[5]`}  className={"form-control"} disabled={disabled} /></td>
                                    </tr>
                                    <tr>
                                        <td><Translator file='module-saicaReports' name='l.t.a' /></td>
                                        <td className="text-center"><Field name={`scorecard.lta[0]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.lta[1]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.lta[2]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.lta[3]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.lta[4]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.lta[5]`}  className={"form-control"} disabled={disabled} /></td>
                                    </tr>
                                    <tr>
                                        <td><Translator file='module-saicaReports' name='m.t' /></td>
                                        <td className="text-center"><Field name={`scorecard.mt[0]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.mt[1]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.mt[2]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.mt[3]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.mt[4]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.mt[5]`}  className={"form-control"} disabled={disabled} /></td>
                                    </tr>
                                    <tr>
                                        <td><Translator file='module-saicaReports' name='f.a' /></td>
                                        <td className="text-center"><Field name={`scorecard.fa[0]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.fa[1]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.fa[2]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.fa[3]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.fa[4]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.fa[5]`}  className={"form-control"} disabled={disabled} /></td>
                                    </tr>
                                    <tr>
                                        <td><Translator file='module-saicaReports' name='days.lost' /></td>
                                        <td className="text-center"><Field name={`scorecard.dl[0]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.dl[1]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.dl[2]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.dl[3]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.dl[4]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.dl[5]`}  className={"form-control"} disabled={disabled} /></td>
                                    </tr>
                                    <tr>
                                        <td><Translator file='module-saicaReports' name='l.t.a.f.r' /></td>
                                        <td className="text-center"><Field name={`scorecard.ltafr[0]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.ltafr[1]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.ltafr[2]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.ltafr[3]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.ltafr[4]`}  className={"form-control"} disabled={disabled} /></td>
                                        <td className="text-center"><Field name={`scorecard.ltafr[5]`}  className={"form-control"} disabled={disabled} /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="row">
                            <div className="col-sm-2 col-md-12 col-lg-3 col-xl-2">
                                <label className="col-form-label">
                                    <Translator file='module-saicaReports' name='comment' />
                                </label>
                            </div>
                            <div className="col-sm-10 col-md-12 col-lg-9 col-xl-10">
                                <Field as={'textarea'} name={`scorecard.comment`} rows="3"  className={"form-control mb-2"} disabled={disabled} />
                            </div>
                        </div>
                    </div>
                </div>
                {nivo && (
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="card widget-container mb-3">
                                <BlockTitle><Translator file='module-saicaReports' name='safety.index' /></BlockTitle>
                                <div style={{height: '250px'}}>
                                    <nivo.ResponsiveBar
                                        data={chart1.data}
                                        keys={['Ratio']}
                                        indexBy="column"
                                        enableLabel={false}
                                        margin={{ top: 50, right: 20, bottom: 50, left: 40 }}
                                        padding={0.3}
                                        colors={{ scheme: 'paired' }}
                                        borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                                        axisTop={null}
                                        axisRight={null}
                                        axisBottom={{
                                            tickSize: 5,
                                            tickPadding: 5,
                                            tickRotation: 0,
                                        }}
                                        axisLeft={{
                                            tickSize: 2,
                                            tickPadding: 5,
                                            tickRotation: 0,
                                        }}
                                        labelSkipWidth={12}
                                        labelSkipHeight={12}
                                        // tooltipFormat={value => Number(value).toLocaleString('es-ES', {minimumFractionDigits: 2}) + ' €'}
                                    />
                                    {/*{*/}
                                    {/*    nivo.ResponsiveBar({*/}
                                    {/*        data:chart1.data,*/}
                                    {/*        keys: ['Ratio'],*/}
                                    {/*        indexBy: "column",*/}
                                    {/*        enableLabel:false,*/}
                                    {/*        margin:{ top: 50, right: 20, bottom: 50, left: 40 },*/}
                                    {/*        padding:0.3,*/}
                                    {/*        colors:{ scheme: 'paired' },*/}
                                    {/*        borderColor:{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] },*/}
                                    {/*        axisTop:null,*/}
                                    {/*        axisRight:null,*/}
                                    {/*        axisBottom:{*/}
                                    {/*            tickSize: 5,*/}
                                    {/*            tickPadding: 5,*/}
                                    {/*            tickRotation: 0,*/}
                                    {/*        },*/}
                                    {/*        axisLeft:{*/}
                                    {/*            tickSize: 2,*/}
                                    {/*            tickPadding: 5,*/}
                                    {/*            tickRotation: 0,*/}
                                    {/*        },*/}
                                    {/*        labelSkipWidth:12,*/}
                                    {/*        labelSkipHeight:12,*/}
                                    {/*    })*/}
                                    {/*}*/}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="card widget-container mb-3">
                                <BlockTitle><Translator file='module-saicaReports' name='l.t.a.f.r' /></BlockTitle>
                                <div style={{height: '250px'}}>
                                    <nivo.ResponsiveBar
                                        data={chart2.data}
                                        keys={['Ratio']}
                                        indexBy="column"
                                        enableLabel={false}
                                        margin={{ top: 50, right: 20, bottom: 50, left: 40 }}
                                        padding={0.3}
                                        colors={{ scheme: 'paired' }}
                                        borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                                        axisTop={null}
                                        axisRight={null}
                                        axisBottom={{
                                            tickSize: 5,
                                            tickPadding: 5,
                                            tickRotation: 0,
                                        }}
                                        axisLeft={{
                                            tickSize: 2,
                                            tickPadding: 5,
                                            tickRotation: 0,
                                        }}
                                        labelSkipWidth={12}
                                        labelSkipHeight={12}
                                        // tooltipFormat={value => Number(value).toLocaleString('es-ES', {minimumFractionDigits: 2}) + ' €'}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="card widget-container mb-3">
                                <BlockTitle><Translator file='module-saicaReports' name='days.lost' /></BlockTitle>
                                <div style={{height: '250px'}}>
                                    <nivo.ResponsiveBar
                                        data={chart3.data}
                                        keys={['Ratio']}
                                        indexBy="column"
                                        enableLabel={false}
                                        margin={{ top: 50, right: 20, bottom: 50, left: 40 }}
                                        padding={0.3}
                                        colors={{ scheme: 'paired' }}
                                        borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                                        axisTop={null}
                                        axisRight={null}
                                        axisBottom={{
                                            tickSize: 5,
                                            tickPadding: 5,
                                            tickRotation: 0,
                                        }}
                                        axisLeft={{
                                            tickSize: 2,
                                            tickPadding: 5,
                                            tickRotation: 0,
                                        }}
                                        labelSkipWidth={12}
                                        labelSkipHeight={12}
                                        // tooltipFormat={value => Number(value).toLocaleString('es-ES', {minimumFractionDigits: 2}) + ' €'}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="card widget-container mb-3">
                                <BlockTitle><Translator file='module-saicaReports' name='l.t.a' /></BlockTitle>
                                <div style={{height: '250px'}}>
                                    <nivo.ResponsiveBar
                                        data={chart4.data}
                                        keys={['Ratio']}
                                        indexBy="column"
                                        enableLabel={false}
                                        margin={{ top: 50, right: 20, bottom: 50, left: 40 }}
                                        padding={0.3}
                                        colors={{ scheme: 'paired' }}
                                        borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                                        axisTop={null}
                                        axisRight={null}
                                        axisBottom={{
                                            tickSize: 5,
                                            tickPadding: 5,
                                            tickRotation: 0,
                                        }}
                                        axisLeft={{
                                            tickSize: 2,
                                            tickPadding: 5,
                                            tickRotation: 0,
                                        }}
                                        labelSkipWidth={12}
                                        labelSkipHeight={12}
                                        // tooltipFormat={value => Number(value).toLocaleString('es-ES', {minimumFractionDigits: 2}) + ' €'}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="card widget-container mb-3">
                                <BlockTitle><Translator file='module-saicaReports' name='m.t' /></BlockTitle>
                                <div style={{height: '250px'}}>
                                    <nivo.ResponsiveBar
                                        data={chart5.data}
                                        keys={['Ratio']}
                                        indexBy="column"
                                        enableLabel={false}
                                        margin={{ top: 50, right: 20, bottom: 50, left: 40 }}
                                        padding={0.3}
                                        colors={{ scheme: 'paired' }}
                                        borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                                        axisTop={null}
                                        axisRight={null}
                                        axisBottom={{
                                            tickSize: 5,
                                            tickPadding: 5,
                                            tickRotation: 0,
                                        }}
                                        axisLeft={{
                                            tickSize: 2,
                                            tickPadding: 5,
                                            tickRotation: 0,
                                        }}
                                        labelSkipWidth={12}
                                        labelSkipHeight={12}
                                        // tooltipFormat={value => Number(value).toLocaleString('es-ES', {minimumFractionDigits: 2}) + ' €'}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="card widget-container mb-3">
                                <BlockTitle><Translator file='module-saicaReports' name='f.a' /></BlockTitle>
                                <div style={{height: '250px'}}>
                                    <nivo.ResponsiveBar
                                        data={chart6.data}
                                        keys={['Ratio']}
                                        indexBy="column"
                                        enableLabel={false}
                                        margin={{ top: 50, right: 20, bottom: 50, left: 40 }}
                                        padding={0.3}
                                        colors={{ scheme: 'paired' }}
                                        borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                                        axisTop={null}
                                        axisRight={null}
                                        axisBottom={{
                                            tickSize: 5,
                                            tickPadding: 5,
                                            tickRotation: 0,
                                        }}
                                        axisLeft={{
                                            tickSize: 2,
                                            tickPadding: 5,
                                            tickRotation: 0,
                                        }}
                                        labelSkipWidth={12}
                                        labelSkipHeight={12}
                                        // tooltipFormat={value => Number(value).toLocaleString('es-ES', {minimumFractionDigits: 2}) + ' €'}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}


            </div>
            <AppModal show={showPasteModal}
              title={<Translator file='module-saicaReports' name='paste.xls.values' />}
              onClose={() => setShowPasteModal(false)}
            >
                <p>
                    <Translator file='module-saicaReports' name='copy.xls.paste.content' />
                </p>
                <p>
                    <Translator file='module-saicaReports' name='no.modify' />
                </p>
                <div className="row">
                    <div className="col-sm-2 col-md-12 col-lg-3 col-xl-2">
                        <label className="col-form-label">
                            <Translator file='module-saicaReports' name='values' />
                        </label>
                    </div>
                    <div className="col-sm-10 col-md-12 col-lg-9 col-xl-10">
                        <textarea ref={pasteValues} className="form-control" style={{resize: 'none'}}></textarea>
                    </div>
                </div>
                <br /><br />
                <span className="btn btn-block btn-info" onClick={() => handlePasteValues()}><AppRemixIcon icon="file-copy" /><Translator file='module-saicaReports' name='paste' /></span>

            </AppModal>
            <AppModal show={showLevelUpModal}
                          isConfirmBtn={false}
                          isCancelBtn={true}
                          cancelBtnText={<Translator file='module-saicaReports' name='cancel' />}
                          title={<Translator file='module-saicaReports' name='level.up' />}
                          onClose={() => {
                              setShowLevelUpModal(false)
                          }}
            >
                <p>
                    <Translator file='module-saicaReports' name='want.level.up.current.state.block' />
                </p>
                <p>
                    <Translator file='module-saicaReports' name='select.tier.level.send' />
                </p>
                {report.levelUpPermissions && (
                    <Select className="mb-3"
                            options={report.levelUpPermissions}
                            onChange={opt => setLevelUpOption(opt.value)}
                            value={levelUpOption ? report.levelUpPermissions.find(p => p.value === levelUpOption) : null}
                    />
                )}
                <span className={`btn btn-info btn-block ${!levelUpOption && 'disabled'}`} onClick={() => levelUpOption && handleLevelUp()}><Translator file='module-saicaReports' name='level.up' /></span>
            </AppModal>
        </div>
    );
};

export default BlockScorecard;

const BlockTitle = styled.h1`
  text-align: center;
  font-size: 32px;
  margin-bottom: 15px;
`;
